








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../../../mti/metadata_pb.js');
var google_protobuf_timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.mti.store.cable.CableType',null,global);
goog.exportSymbol('proto.mti.store.cable.State',null,global);











proto.mti.store.cable.State=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.cable.State,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.cable.State.displayName='proto.mti.store.cable.State';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.cable.State.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.cable.State.toObject(opt_includeInstance,this);
};











proto.mti.store.cable.State.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
stateUuid:msg.getStateUuid_asB64(),
stateUpdatedAt:(f=msg.getStateUpdatedAt())&&google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance,f),
cableSerialNumber:jspb.Message.getFieldWithDefault(msg,5,""),
nodeSerialNumber:jspb.Message.getFieldWithDefault(msg,6,""),
portNumber:jspb.Message.getFieldWithDefault(msg,7,0),
cableType:jspb.Message.getFieldWithDefault(msg,8,0),
modelNumber:jspb.Message.getFieldWithDefault(msg,9,""),
cableVersion:jspb.Message.getFieldWithDefault(msg,10,"")};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.cable.State.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.cable.State();
return proto.mti.store.cable.State.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.cable.State.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readBytes();
msg.setStateUuid(value);
break;
case 4:
var value=new google_protobuf_timestamp_pb.Timestamp();
reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
msg.setStateUpdatedAt(value);
break;
case 5:
var value=reader.readString();
msg.setCableSerialNumber(value);
break;
case 6:
var value=reader.readString();
msg.setNodeSerialNumber(value);
break;
case 7:
var value=reader.readUint32();
msg.setPortNumber(value);
break;
case 8:
var value=reader.readEnum();
msg.setCableType(value);
break;
case 9:
var value=reader.readString();
msg.setModelNumber(value);
break;
case 10:
var value=reader.readString();
msg.setCableVersion(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.cable.State.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.cable.State.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.cable.State.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getStateUuid_asU8();
if(f.length>0){
writer.writeBytes(
3,
f);

}
f=message.getStateUpdatedAt();
if(f!=null){
writer.writeMessage(
4,
f,
google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);

}
f=message.getCableSerialNumber();
if(f.length>0){
writer.writeString(
5,
f);

}
f=message.getNodeSerialNumber();
if(f.length>0){
writer.writeString(
6,
f);

}
f=message.getPortNumber();
if(f!==0){
writer.writeUint32(
7,
f);

}
f=message.getCableType();
if(f!==0.0){
writer.writeEnum(
8,
f);

}
f=message.getModelNumber();
if(f.length>0){
writer.writeString(
9,
f);

}
f=message.getCableVersion();
if(f.length>0){
writer.writeString(
10,
f);

}
};






proto.mti.store.cable.State.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.store.cable.State.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.store.cable.State.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.store.cable.State.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.store.cable.State.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.store.cable.State.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.store.cable.State.prototype.getStateUuid=function(){
return jspb.Message.getFieldWithDefault(this,3,"");
};







proto.mti.store.cable.State.prototype.getStateUuid_asB64=function(){
return jspb.Message.bytesAsB64(
this.getStateUuid());
};









proto.mti.store.cable.State.prototype.getStateUuid_asU8=function(){
return jspb.Message.bytesAsU8(
this.getStateUuid());
};



proto.mti.store.cable.State.prototype.setStateUuid=function(value){
jspb.Message.setProto3BytesField(this,3,value);
};






proto.mti.store.cable.State.prototype.getStateUpdatedAt=function(){
return(
jspb.Message.getWrapperField(this,google_protobuf_timestamp_pb.Timestamp,4));
};



proto.mti.store.cable.State.prototype.setStateUpdatedAt=function(value){
jspb.Message.setWrapperField(this,4,value);
};


proto.mti.store.cable.State.prototype.clearStateUpdatedAt=function(){
this.setStateUpdatedAt(undefined);
};






proto.mti.store.cable.State.prototype.hasStateUpdatedAt=function(){
return jspb.Message.getField(this,4)!=null;
};






proto.mti.store.cable.State.prototype.getCableSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,5,"");
};



proto.mti.store.cable.State.prototype.setCableSerialNumber=function(value){
jspb.Message.setProto3StringField(this,5,value);
};






proto.mti.store.cable.State.prototype.getNodeSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,6,"");
};



proto.mti.store.cable.State.prototype.setNodeSerialNumber=function(value){
jspb.Message.setProto3StringField(this,6,value);
};






proto.mti.store.cable.State.prototype.getPortNumber=function(){
return jspb.Message.getFieldWithDefault(this,7,0);
};



proto.mti.store.cable.State.prototype.setPortNumber=function(value){
jspb.Message.setProto3IntField(this,7,value);
};






proto.mti.store.cable.State.prototype.getCableType=function(){
return jspb.Message.getFieldWithDefault(this,8,0);
};



proto.mti.store.cable.State.prototype.setCableType=function(value){
jspb.Message.setProto3EnumField(this,8,value);
};






proto.mti.store.cable.State.prototype.getModelNumber=function(){
return jspb.Message.getFieldWithDefault(this,9,"");
};



proto.mti.store.cable.State.prototype.setModelNumber=function(value){
jspb.Message.setProto3StringField(this,9,value);
};






proto.mti.store.cable.State.prototype.getCableVersion=function(){
return jspb.Message.getFieldWithDefault(this,10,"");
};



proto.mti.store.cable.State.prototype.setCableVersion=function(value){
jspb.Message.setProto3StringField(this,10,value);
};





proto.mti.store.cable.CableType={
NOCABLECONNECTED:0,
USBC:1,
MICROUSB:2,
LIGHTNING:3,
USBCALARMSENSOR:4,
MICROUSBALARMSENSOR:5,
FLEXIDISC:6,
AUDIOFLEXIDISC:7,
WEARABLE:8,
LOOP:9,
CLIP:10,
STYLUS:11,
ONESENSOR:12,
TWOSENSORS:13,
MECHANICALONLY:14,
PORTNOTSUPPORTED:254,
UNKNOWNCABLECONNECTED:255};


goog.object.extend(exports,proto.mti.store.cable);